import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { intlShape } from 'react-intl';

export const BreadcrumbItem = ({
  step,
  text,
  className,
  disabled,
  selected,
  onClick,
  arrow,
  link,
  intl
}) => {
  const inactive = !onClick;
  const stepClickHandler = (event) => {
    if (!link) {
      event.preventDefault();
    }
    if (!inactive) {
      onClick(step);
    }
  };

  return (
    <a className={classnames('flex space-between baseline', { inactive, disabled: !inactive && disabled })} onClick={stepClickHandler} href={link || '#'} data-testing-id="breadcrumb-item">
      <p className={classnames({ selected }, 'text-gray-500', className)}>
        {text}
      </p>
      {
        arrow && <img
          className="margin-lg-right margin-lg-left"
          src="/web-2/assets/images/arrow.svg?v=rb"
          alt={ intl.formatMessage({ id: 'inbox.breadcrumb.arrow', defaultMessage: 'arrow' }) }
        />
      }
    </a>
  );
};

BreadcrumbItem.propTypes = {
  step: PropTypes.number,
  text: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  arrow: PropTypes.bool,
  link: PropTypes.string,
  onClick: PropTypes.func,
  intl: intlShape
};
